import React from 'react';
import {IconProps} from '../icon/IconProps';

/**
 * Interactive icon highlighted on hover
 *
 * @return {JSX.Element}
 * @constructor
 */
export default function InteractiveIcon(props: IconProps & { children?: React.ReactElement }) {
  return (
    <span className="rounded-sm w-6 text-center inline-block mr-0.5 hover:bg-gray-light">
      {props.children &&
      React.cloneElement(props.children, {className: 'sort-handle hover:cursor-pointer hover:bg-gray-light'})}
    </span>
  );
}
